import e, { createContext as t, createElement as n, forwardRef as r, useCallback as i, useEffect as a, useImperativeHandle as o, useLayoutEffect as s, useMemo as c, useRef as l, useState as u } from "react";
import { useFactory as d, useInstance as f, useResources as p, useRouter as m, useSignal as h, useStrictContext as g, useStrictInstance as _ } from "@funtech-int/rival-react";
import { createFlags as v, createRef as y, createResourceQuery as ee, createSignal as b } from "@funtech-int/rival";
import { Fragment as x, jsx as S, jsxs as C } from "react/jsx-runtime";
import { stringifyUrl as w } from "query-string";
import { useIntl as te } from "react-intl";
import { createPortal as ne } from "react-dom";
import { GeoWidgetTriggerWrapper as T } from "@funtech-int/i18n-geo-widget/lazy";
import { RequestIdsHeader as E, clientRequestIdParser as re, createRequestIdFactory as ie, getRequestId as ae, serverRequestIdParser as oe } from "@kinopoisk-int/request-ids";
import { Offers as se, PWTools as ce, WidgetRouterWeb as le } from "@plus-int/acq-toolkit";
import { Dcb as ue } from "@plus-int/acq-toolkit/dcb";
//#region \0rolldown/runtime.js
var de = Object.defineProperty, fe = (e, t) => {
	let n = {};
	for (var r in e) de(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || de(n, Symbol.toStringTag, { value: "Module" }), n;
};
//#endregion
//#region src/lib/analytics.ts
function pe(e) {
	if (!e) throw Error("Evgen is not initialized");
}
function me(e) {
	let t = /* @__PURE__ */ new Set();
	function n(t, n, r) {
		return pe(e), r?.namespace ? t(e, r.namespace, n) : t(e, n);
	}
	return {
		send: n,
		sendOnce(e, r, i) {
			let a = i?.key ?? JSON.stringify(r);
			t?.has(a) || (t?.add(a), n(e, r, i));
		}
	};
}
//#endregion
//#region ../../../../../../../../../../../../home/sandbox/.nots/pnpm_store/v10/links/@kinopoisk-int/evgen-web-events/1.362.0/2dbe9843561c7ebff2c1aa10126c144bb664b72c33abf64664d34327c55354ae/node_modules/@kinopoisk-int/evgen-web-events/web/evgen_analytics.ts
var he = /* @__PURE__ */ function(e) {
	return e.Android = "android", e.Ios = "ios", e.AndroidTv = "android_tv", e.HarmonyTv = "harmony_tv", e.ZeasnTv = "zeasn_tv", e.YandexTv = "yandex_tv", e.Tvos = "tvos", e.Tizen = "tizen", e.Orsay = "orsay", e.Webos = "webos", e.Playstation4 = "playstation4", e.Playstation5 = "playstation5", e.Xbox = "xbox", e.Web = "web", e.AospTv = "aosp_tv", e.Vidaa = "vidaa", e.Tvip = "tvip", e.Mina = "mina", e.Visionos = "visionos", e;
}({}), ge = /* @__PURE__ */ function(e) {
	return e.Yes = "yes", e.No = "no", e;
}({}), _e = /* @__PURE__ */ function(e) {
	return e.DefaultRegion = "default_region", e.Ip = "ip", e.Geo = "geo", e.Manual = "manual", e;
}({}), ve = /* @__PURE__ */ function(e) {
	return e.Ltr = "ltr", e.Rtl = "rtl", e.NotSupported = "not_supported", e;
}({});
function ye(e, t, n) {
	return { trackEvent: (r, i) => {
		let a = {
			...i,
			...t.getGlobalParams(),
			...n.getPlatformParams()
		};
		e.trackEvent(r, a);
	} };
}
//#endregion
//#region src/lib/tracking.ts
var be = "service-id", xe = class {
	logger;
	apiUrl;
	serviceId;
	constructor({ trackingBaseUrl: e, serviceId: t, logger: n }) {
		this.apiUrl = `${e}/watch-batch`, this.serviceId = t, this.logger = n;
	}
	trackEvent(e, t) {
		let n = JSON.stringify([{
			...t,
			eventName: e
		}]);
		return navigator.sendBeacon && window.Blob && navigator.sendBeacon(this.apiUrl, new Blob([n], { type: "application/json" })) ? Promise.resolve() : fetch(this.apiUrl, {
			body: n,
			method: "POST",
			...this.serviceId ? { headers: { [be]: String(this.serviceId) } } : {}
		}).catch((e) => {
			this.logger?.error({ error: e }, "Failed to track EvGen analytics data"), e instanceof Error && this.logger?.error({ error: e }, e.message);
		});
	}
}, Se = class {
	providers;
	constructor({ providers: e }) {
		this.providers = e;
	}
	trackEvent(e, t) {
		this.providers.forEach((n) => n.trackEvent(e, t));
	}
}, Ce = class {
	provider;
	constructor(e) {
		this.provider = e;
	}
	trackEvent(e, t) {
		this.provider.trackEvent(e, t);
	}
};
function we(e) {
	return [
		`%c[Evgen]%c %c[trackEvent]%c %c[${e}]`,
		"color: #fff; font-weight: bold; background: #194B77",
		null,
		"color: #fff; background: #806d3e",
		null,
		"color: #fff; background: #4f4473"
	];
}
var Te = class extends Ce {
	logger = console;
	hasDebugCookie = document.cookie.includes("_kp_debug=");
	constructor(e, t = we) {
		super(e), this.getEventMessageHeader = t;
	}
	trackEvent(e, t) {
		this.hasDebugCookie && this.logger.debug(...this.getEventMessageHeader(e), t), super.trackEvent(e, t);
	}
}, D = y("evgen"), Ee = "unauthorized", De = "no–subscriptions", Oe = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content"
];
function O(e) {
	return e ?? "-";
}
function ke(e, t) {
	return { getPlatformParams() {
		return {
			appVersion: e,
			yandexuid: O(t),
			referer: O(document.referrer),
			url: window.location.href
		};
	} };
}
function Ae({ featureFlags: e, authManager: t, trackedQueryParamsStore: n, locale: r, runtimeConfig: i, serviceName: a, sessionIds: o }) {
	return { getGlobalParams() {
		let s = n.getParams(Oe), c = t.userProfile?.billingFeatureNames, { isAuthorized: l } = t;
		return c?.length || (c = l ? [De] : [Ee]), {
			experimentsFilter: {},
			deviceId: "-",
			platformName: he.Web,
			osVersion: "-",
			cityName: "-",
			regionSource: _e.Ip,
			subscriptionType: "-",
			globalSessionId: O(o?.globalSessionId),
			localSessionId: O(o?.localSessionId.get()),
			featureToggles: {},
			experiments: e.grouped,
			regionId: O(String(i.regionId)),
			kpuid: "-",
			auth: l ? ge.Yes : ge.No,
			subprofileId: "-",
			childMode: !1,
			puid: t?.userProfile?.puid ? String(t?.userProfile.puid) : "-",
			billingFeatureNames: c,
			utmCampaign: O(s.utm_campaign),
			utmMedium: O(s.utm_medium),
			utmSource: O(s.utm_source),
			serviceName: a,
			lang: r.lang,
			textDirection: r.dir === "ltr" ? ve.Ltr : ve.Rtl,
			eventTimestamp: Date.now().toString()
		};
	} };
}
function je({ featureFlags: e, logger: t, authManager: n, trackedQueryParamsStore: r, locale: i, runtimeConfig: a, serviceName: o, sessionIds: s, appVersion: c, yandexuid: l, trackingsHost: u, metrikaProvider: d }) {
	let f = ke(c, l), p = Ae({
		featureFlags: e,
		authManager: n,
		trackedQueryParamsStore: r,
		locale: i,
		runtimeConfig: a,
		serviceName: o,
		sessionIds: s
	});
	return {
		...ye(new Te(new Se({ providers: [new xe({
			trackingBaseUrl: u,
			logger: t
		}), d] })), p, f),
		ref: () => D
	};
}
//#endregion
//#region src/hooks/useEvgen.ts
function Me() {
	return f(D);
}
//#endregion
//#region src/components/AnalyticsSenderProvider/AnalyticsSenderContext.ts
var Ne = t(null), Pe = ({ children: e }) => {
	let t = Me(), n = d(() => me(t));
	return /* @__PURE__ */ S(Ne.Provider, {
		value: n,
		children: e
	});
};
//#endregion
//#region src/hooks/useAnalytics.ts
function Fe(e) {
	let t = g(Ne);
	return d(() => e(t));
}
//#endregion
//#region src/lib/fromBlock.ts
var Ie = "deviceUuid";
function Le(e) {
	return e.local.get(Ie) ?? void 0;
}
function Re(e) {
	return `${Le(e)}_${Date.now()}`;
}
var ze = y("fromBlock"), Be = (e) => {
	let t = Re(e), n = 0, r = b(`${t}_${n}`);
	return {
		get sessionIds() {
			return {
				globalSessionId: t,
				localSessionId: r.seal()
			};
		},
		updateSession() {
			n += 1, r.set(`${t}_${n}`);
		},
		ref() {
			return ze;
		}
	};
};
//#endregion
//#region src/hooks/useFromBlock.ts
function Ve() {
	return _(ze);
}
function He(t) {
	let n = Ve();
	e.useEffect(() => {
		t && n && n.updateSession();
	}, [t, n]);
}
//#endregion
//#region src/components/SeoDefaultContext/SeoDefaultContext.ts
var Ue = t(null), k = () => g(Ue), We = ({ url: e, lang: t, host: n, queryParams: r = {} }) => w({
	url: `${n}/${t}${e}`,
	query: r
}), Ge = ({ url: e, locales: t, host: n, queryParams: r = {} }) => t.map((t) => ({
	href: w({
		url: `${n}/${t}${e}`,
		query: r
	}),
	hreflang: t
})), A = (e) => {
	let { currentLang: t } = k();
	return m().serialize(e)?.replace(RegExp(`^/${t}`), "");
}, Ke = ({ seoTitle: e, seoDescription: t, location: n, queryParams: r }) => {
	let i = k(), { Head: a, FaviconLinks: o } = i, s = A(n), c = We({
		url: s,
		lang: i.currentLang,
		host: i.hostOrigin,
		queryParams: r
	}), l = Ge({
		url: s,
		locales: i.locales,
		host: i.hostOrigin,
		queryParams: r
	});
	return /* @__PURE__ */ C(x, { children: [/* @__PURE__ */ C(a, { children: [
		/* @__PURE__ */ S("title", { children: e }, "title"),
		/* @__PURE__ */ S("meta", {
			name: "description",
			content: t
		}),
		/* @__PURE__ */ S("link", {
			rel: "canonical",
			href: c
		}, "canonical"),
		l.map(({ href: e, hreflang: t }) => /* @__PURE__ */ S("link", {
			rel: "alternate",
			href: e,
			hrefLang: t
		}, `${t}_alternate`))
	] }), /* @__PURE__ */ S(o, {})] });
}, qe = ({ location: e, ogTitle: t, ogDescription: n, ogImage: r, ogImageWidth: i, ogImageHeight: a, ogImageAlt: o, ogType: s, queryParams: c }) => {
	let l = k(), u = A(e), { Head: d } = l, f = r || l.seoImage.url, p = i || l.seoImage.width, m = a || l.seoImage.height, h = We({
		url: u,
		lang: l.currentLang,
		host: l.hostOrigin,
		queryParams: c
	});
	return /* @__PURE__ */ C(d, { children: [
		/* @__PURE__ */ S("meta", {
			property: "og:site_name",
			content: l.seoSiteName
		}, "og:site_name"),
		/* @__PURE__ */ S("meta", {
			property: "og:type",
			content: s
		}, "og:type"),
		/* @__PURE__ */ S("meta", {
			property: "og:title",
			content: t
		}, "og:title"),
		/* @__PURE__ */ S("meta", {
			property: "og:description",
			content: n
		}, "og:description"),
		/* @__PURE__ */ S("meta", {
			property: "og:url",
			content: h
		}, "og:url"),
		/* @__PURE__ */ S("meta", {
			property: "og:image",
			content: f
		}, "og:image"),
		/* @__PURE__ */ S("meta", {
			property: "og:image:width",
			content: String(p)
		}, "og:image:width"),
		/* @__PURE__ */ S("meta", {
			property: "og:image:height",
			content: String(m)
		}, "og:image:height"),
		!!o && /* @__PURE__ */ S("meta", {
			property: "og:image:alt",
			content: o
		}, "og:image:alt")
	] });
}, Je = (e) => /* @__PURE__ */ S(qe, {
	...e,
	ogType: "website"
}), Ye = ({ ogVideoDuration: e, ogVideoTags: t, ...n }) => {
	let { Head: r } = k();
	return /* @__PURE__ */ C(x, { children: [/* @__PURE__ */ S(qe, {
		...n,
		ogType: "video.movie"
	}), /* @__PURE__ */ C(r, { children: [!!e && /* @__PURE__ */ S("meta", {
		property: "video:duration",
		content: String(e)
	}, "video:duration"), !!t && t?.map((e) => /* @__PURE__ */ S("meta", {
		property: "og:video:tag",
		content: e
	}, e))] })] });
}, Xe = ({ twitterCard: e = "summary_large_image", twitterImage: t, twitterDescription: n }) => {
	let r = k(), { Head: i } = r, a = t || r.seoImage.url;
	return /* @__PURE__ */ C(i, { children: [
		/* @__PURE__ */ S("meta", {
			name: "twitter:card",
			content: e
		}),
		/* @__PURE__ */ S("meta", {
			name: "twitter:image",
			content: a
		}, "twitter:image"),
		/* @__PURE__ */ S("meta", {
			property: "twitter:description",
			content: n
		}, "twitter:description")
	] });
}, Ze = ({ scripts: e = [] }) => {
	let { Head: t } = k();
	return /* @__PURE__ */ S(t, { children: e.map(({ id: e, data: t }) => /* @__PURE__ */ n("script", {
		...t,
		key: e
	})) });
}, Qe = (e) => ({
	icon: `${e}/favicon.ico`,
	svg: `${e}/favicon.svg`,
	appleTouchIcon: `${e}/apple-touch-icon.png`,
	appleTouchIcon152: `${e}/apple-touch-icon-152x152.png`,
	appleTouchIcon167: `${e}/apple-touch-icon-167x167.png`,
	appleTouchIcon180: `${e}/apple-touch-icon-180x180.png`
}), $e = () => {
	let { Head: e, hostOrigin: t } = k(), n = Qe(t ?? "");
	return /* @__PURE__ */ C(e, { children: [
		/* @__PURE__ */ S("link", {
			rel: "icon",
			href: n.icon,
			sizes: "16x16 32x32 48x48",
			type: "image/x-icon"
		}),
		/* @__PURE__ */ S("link", {
			rel: "icon",
			href: n.svg,
			sizes: "any",
			type: "image/svg+xml"
		}),
		/* @__PURE__ */ S("link", {
			rel: "apple-touch-icon",
			href: n.appleTouchIcon
		}),
		/* @__PURE__ */ S("link", {
			rel: "apple-touch-icon",
			sizes: "152x152",
			href: n.appleTouchIcon152
		}),
		/* @__PURE__ */ S("link", {
			rel: "apple-touch-icon",
			sizes: "167x167",
			href: n.appleTouchIcon167
		}),
		/* @__PURE__ */ S("link", {
			rel: "apple-touch-icon",
			sizes: "180x180",
			href: n.appleTouchIcon180
		})
	] });
}, et = ({ links: e }) => {
	let { Head: t } = k();
	return /* @__PURE__ */ S(t, { children: e.map((e) => /* @__PURE__ */ S("link", {
		rel: "preload",
		...e
	}, e.href)) });
}, tt = ({ seoDefaultValues: e, children: t }) => /* @__PURE__ */ S(Ue.Provider, {
	value: e,
	children: t
}), nt = /* @__PURE__ */ fe({
	BasicMeta: () => Ke,
	FaviconLinks: () => $e,
	OgVideoMeta: () => Ye,
	OgWebsiteMeta: () => Je,
	PreloadLinks: () => et,
	Provider: () => tt,
	StructuredData: () => Ze,
	TwitterMeta: () => Xe
}), rt = {
	home_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.c9ca44c0776e1a7a35219eb3c29b1842" }, { brandName: t }),
	home_seo_description: (e) => e.formatMessage({ id: "yango-shared.i18n.c3ee1bbda67aef5101a6a3b5eaeea26e" }),
	music_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.247eaea9c7b59c177155adace28cd307" }, { brandName: t }),
	music_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.f119440a78b551b3d71830059cbdae0a" }),
	yasmina_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.75183bf6eff3525e541a3f5b89ea6215" }, { brandName: t }),
	yasmina_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.b272833b5b03acfc8a60a7a80702562b" }, { brandName: t }),
	crunchyroll_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.432259e6e890ffddcb9e4a0a971037e4" }, { brandName: t }),
	crunchyroll_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.d9c3467b19748eac900efdf403079e81" }),
	cari_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.00f40372932ef576ddede55ffe815fc6" }, { brandName: t }),
	cari_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.31bb5fa8d62e447960af5150adb043c9" }, { brandName: t }),
	talabat_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.69ede0a45134e1ee040e337756fe864e" }, { brandName: t }),
	talabat_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.e10f5e1d5fee3ccbc50ec44fb7676f46" }, { brandName: t }),
	settings_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.68c59d81e48e440b99a82bdcad8961a1" }, { brandName: t }),
	settings_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.9688895733f2180a01790bbedf7c587f" }, { brandName: t }),
	selection__seo_title: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.c7eb6a2b3ae99b848674ba6d9c36ed20" }, {
		title: t,
		brandName: n
	}),
	selection__meta_description: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.097c644db94478882376918ebfad27a2" }, {
		title: t,
		brandName: n
	}),
	person_seo_title: (e, { name: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.61c0cb332e69b16aea91ab6c574103bb" }, {
		name: t,
		brandName: n
	}),
	person_meta_description: (e, { name: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.4a2b1622365c1ede99f508a8d276d67b" }, {
		name: t,
		brandName: n
	}),
	movie__film_seo_title: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.7a62bce6cc9912ff858ce9fcca27d57b" }, {
		title: t,
		brandName: n
	}),
	movie__film_meta_description: (e, { title: t, yearAndCountry: n, brandName: r }) => e.formatMessage({ id: "yango-shared.i18n.8e6dad65dfae6b8e3942b7cc080213aa" }, {
		title: t,
		yearAndCountry: n,
		brandName: r
	}),
	movie__film_seo_year_and_country: (e, { ottProductionYear: t, comma: n, country: r }) => e.formatMessage({ id: "yango-shared.i18n.e992b42b390806724b27faeaaf73168d" }, {
		ottProductionYear: t,
		comma: n,
		country: r
	}),
	movie__series_seo_title: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.5093e6fda1dcfbcac8dc2566c70be304" }, {
		title: t,
		brandName: n
	}),
	movie__series_meta_description: (e, { title: t, years: n, brandName: r }) => e.formatMessage({ id: "yango-shared.i18n.11455b8a68f1719fcc4d377f81367677" }, {
		title: t,
		years: n,
		brandName: r
	}),
	channels_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.197a4c17d41a7616ff16d048a4e73281" }, { brandName: t }),
	channels_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.da762b9acab6aba6c1843a0455d7db9b" }, { brandName: t }),
	history_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.81189435bb53a57af303dc2ab7ea7473" }, { brandName: t }),
	history_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.75cd3553ced0fa9ea3c5261c3725fd64" }, { brandName: t }),
	personal_collection_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.641d5ca4a091775c74cc25366426da0e" }, { brandName: t }),
	personal_collection_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.2268bd9c28cfeb283da1c836ac0e4e6b" }),
	profiles_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.064bb4b609654f4c4161e334d06ff9a9" }, { brandName: t }),
	profiles_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.7de5a32eb16b914f8c63f98cbe48d341" }),
	admin_add_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.37ac7ab3ce71b2288486d2c8ed1fd011" }, { brandName: t }),
	admin_add_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.fcfecb380c0f126e150722e79cffa0b9" })
};
//#endregion
//#region src/lib/i18n.ts
function it(e) {
	return function() {
		let t = te();
		return i((n, r) => e[n](t, r), [t]);
	};
}
//#endregion
//#region src/hooks/useI18n.ts
var at = it(rt);
//#endregion
//#region ../../../../../../../../../../../../home/sandbox/.nots/pnpm_store/v10/links/@/clsx/2.1.1/31a8239809d68b055357418aaab3ba5139c779aca23636c4138978433c48d592/node_modules/clsx/dist/clsx.mjs
function ot(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = ot(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function j() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = ot(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region src/hooks/useOuterClick.ts
function st(e, t, n = !0) {
	a(() => {
		if (!n) return;
		let r = (n) => {
			e.current && !e.current.contains(n.target) && t();
		};
		return document.addEventListener("mousedown", r), () => {
			document.removeEventListener("mousedown", r);
		};
	}, [
		e,
		t,
		n
	]);
}
var M = {
	root: "Tooltip_root__n5UjR",
	startAlignment: "Tooltip_startAlignment__1Arqg",
	withChevronOnLeft: "Tooltip_withChevronOnLeft__Y_N1P",
	tail: "Tooltip_tail__jB1I0",
	middleAlignment: "Tooltip_middleAlignment__9SEnD",
	endAlignment: "Tooltip_endAlignment__raLQx",
	withChevronOnRight: "Tooltip_withChevronOnRight__VD887",
	closeButton: "Tooltip_closeButton__FtR9c",
	withChevronAtTop: "Tooltip_withChevronAtTop__RmE54",
	withChevronAtBottom: "Tooltip_withChevronAtBottom__9TL1N",
	secondary: "Tooltip_secondary__c43jb",
	portal: "Tooltip_portal__hUhFz",
	tooltipSlideIn: "Tooltip_tooltipSlideIn__wNHkD",
	text: "Tooltip_text__tZmbZ"
}, ct = (e) => /* @__PURE__ */ S("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.4rem",
	height: "2.4rem",
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ S("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m2.652-13.849L12 10.303 9.349 7.65 7.65 9.35 10.303 12 7.65 14.652l1.698 1.697L12 13.697l2.652 2.652 1.697-1.697L13.697 12l2.652-2.651z",
		clipRule: "evenodd"
	})
}), lt = (e) => /* @__PURE__ */ S("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.4rem",
	height: "1rem",
	fill: "none",
	viewBox: "0 0 24 10",
	...e,
	children: /* @__PURE__ */ S("path", {
		fill: "currentColor",
		d: "M9.839 1.044c1.092-1.392 3.23-1.392 4.322 0l4.043 5.155A7.36 7.36 0 0 0 24 9v1H0V9a7.36 7.36 0 0 0 5.796-2.8z"
	})
}), N = /* @__PURE__ */ function(e) {
	return e.Text = "tooltip.text", e.CloseButton = "tooltip.closeButton", e;
}(N || {});
function ut(e) {
	return e === "start" ? "end" : e === "end" ? "start" : e;
}
function dt(e) {
	switch (e) {
		case "top": return "bottom";
		case "bottom": return "top";
		case "left": return "right";
		case "right": return "left";
		default: return e;
	}
}
var ft = {
	left: M.withChevronOnLeft,
	right: M.withChevronOnRight,
	top: M.withChevronAtTop,
	bottom: M.withChevronAtBottom
}, pt = {
	start: M.startAlignment,
	middle: M.middleAlignment,
	end: M.endAlignment
};
function mt(e, t, n, r) {
	let i = e.left + window.scrollX, a = i + e.width / 2, o = e.top + e.height / 2 + window.scrollY, s = {
		position: "absolute",
		right: "auto"
	}, c = {
		...s,
		top: o
	}, l = {
		...s,
		left: r ? i : a,
		width: r ? e.width : void 0
	};
	switch (t) {
		case "top": return {
			...l,
			top: e.top + window.scrollY - n,
			transform: r ? "translateY(-100%)" : "translate(-50%, -100%)"
		};
		case "bottom": return {
			...l,
			top: e.bottom + window.scrollY + n,
			transform: r ? void 0 : "translateX(-50%)"
		};
		case "left": return {
			...c,
			left: i - n,
			transform: "translate(-100%, -50%)"
		};
		case "right": return {
			...c,
			left: e.right + window.scrollX + n,
			transform: "translateY(-50%)"
		};
		default: return s;
	}
}
var ht = ({ children: e, visible: t, direction: n = "bottom", alignment: r = "end", className: i, ariaHidden: o, closeLabel: s, withOuterClick: c = !0, showCloseButton: d = !0, onCloseClick: f, viewVariant: p, anchorRef: m, inheritWidth: h = !0, mainOffset: g = 10, ..._ }) => {
	let [v, y] = u(t), ee = l(null), [b, x] = u({}), w = dt(n), te = ut(r);
	if (a(() => {
		!m?.current || !t || x(mt(m.current.getBoundingClientRect(), n, g, h));
	}, [
		m,
		t,
		n,
		h,
		g
	]), st(ee, () => {
		y(!1), f?.();
	}, c && v), !v || !t) return null;
	let T = /* @__PURE__ */ C("div", {
		ref: ee,
		className: j(i, M.root, ft[w], pt[te], p === "secondary" && M.secondary, m && M.portal),
		style: m ? b : void 0,
		"aria-hidden": o,
		..._,
		children: [
			/* @__PURE__ */ S(lt, { className: M.tail }),
			/* @__PURE__ */ S("span", {
				"data-testid": N.Text,
				className: M.text,
				children: e
			}),
			d && /* @__PURE__ */ S("button", {
				"data-testid": N.CloseButton,
				onClick: () => {
					f?.(), y(!1);
				},
				type: "button",
				className: M.closeButton,
				"aria-label": s,
				children: /* @__PURE__ */ S(ct, {})
			})
		]
	});
	return m ? ne(T, document.body) : T;
}, P = {
	ae: "+000 (00) 000 0000",
	ae_zero: "+000 (0) 00 000 0000",
	bh: "+000 0000 0000",
	eg: "+00 (000) 000 0000",
	jo: "+000 (0) 0000 0000",
	kw: "+000 0000 0000",
	om: "+000 (00) 000000",
	qa: "+000 0000 0000",
	sa_without_zero: "+000 (00) 000 0000",
	sa_with_zero: "+000 (000) 000 0000",
	universal: "+000 000 000 000"
}, gt = [
	{
		mask: P.eg,
		startsWith: "20"
	},
	{
		mask: P.bh,
		startsWith: "973"
	},
	{
		mask: P.jo,
		startsWith: "962"
	},
	{
		mask: P.kw,
		startsWith: "965"
	},
	{
		mask: P.sa_with_zero,
		startsWith: "9660"
	},
	{
		mask: P.sa_without_zero,
		startsWith: "966"
	},
	{
		mask: P.om,
		startsWith: "968"
	},
	{
		mask: P.ae_zero,
		startsWith: "9710"
	},
	{
		mask: P.ae,
		startsWith: "971"
	},
	{
		mask: P.qa,
		startsWith: "974"
	},
	{
		mask: P.universal,
		startsWith: ""
	}
], _t = {
	ae: "971",
	bh: "973",
	eg: "20",
	jo: "962",
	kw: "965",
	om: "968",
	qa: "974",
	sa: "966"
}, F = (e, t) => {
	let n = I(e);
	if (n === "") {
		if (t) {
			let e = _t[t.toLowerCase()];
			if (e) {
				let t = gt.find(({ startsWith: t }) => e.startsWith(t));
				if (t) {
					let e = 15 - I(t.mask).length;
					return {
						mask: t.mask + Array(Math.max(e, 0)).fill("0").join(""),
						placeholder: t.mask
					};
				}
			}
		}
		return {
			mask: P.universal,
			placeholder: P.universal
		};
	}
	let r = gt.find(({ startsWith: e }) => n.startsWith(e));
	if (!r) return {
		mask: P.universal,
		placeholder: P.universal
	};
	let i = 15 - I(r.mask).length;
	return {
		mask: r.mask + Array(Math.max(i, 0)).fill("0").join(""),
		placeholder: r.mask
	};
}, vt = (e, t) => {
	let n = I(e), r = "", i = 0;
	for (let e = 0; e < t.length && i < n.length; e++) t[e] === "0" ? (r += n[i], i += 1) : r += t[e];
	return r;
}, I = (e) => e.replace(/[^0-9]+/g, ""), yt = (e) => {
	let t = I(e);
	return t ? t.startsWith("971") ? "ae" : t.startsWith("973") ? "bh" : t.startsWith("20") ? "eg" : t.startsWith("962") ? "jo" : t.startsWith("965") ? "kw" : t.startsWith("968") ? "om" : t.startsWith("974") ? "qa" : t.startsWith("966") ? "sa" : "" : "";
}, bt = (e) => _t[e.toLowerCase()] || "", xt = (e) => {
	let { phone: t, getCurrentIso2: n, handleChange: r, handleClear: i } = d(() => {
		let t = b(""), n = "", r = !1;
		if (e) {
			let i = bt(e);
			if (i) {
				let a = F(i, e);
				n = e, t.set(vt(i, a.mask)), r = !0;
			}
		}
		let i = () => t.get() ? n || "" : r ? "" : e || "";
		return {
			phone: t.seal(),
			internalIso2: n,
			isInitialized: r,
			getCurrentIso2: i,
			handleChange: (e) => {
				let a = I(e.target.value);
				if (a.length <= 15) {
					let e = yt(a), o = i(), s = vt(a, F(a, e || o).mask);
					t.set(s), s ? (n = e || "", r = !0) : n = "";
				}
			},
			handleClear: () => {
				t.set(""), n = "";
			}
		};
	});
	return {
		phone: h(t),
		iso2: n(),
		handleChange: r,
		handleClear: i
	};
}, L = {
	root: "PhoneInput_root__ndVt8",
	field: "PhoneInput_field__rHxXW",
	flagButton: "PhoneInput_flagButton__VGT1Y",
	inputWrapper: "PhoneInput_inputWrapper___FqC6",
	mask: "PhoneInput_mask__79u0Z",
	maskVisible: "PhoneInput_maskVisible__dO-r0",
	input: "PhoneInput_input__4aD1f",
	clearButton: "PhoneInput_clearButton__3ebx2"
}, R = {
	flagContainer: "CountryFlag_flagContainer__Z-N5O",
	flagEmoji: "CountryFlag_flagEmoji__b38Bv",
	flagGlobe: "CountryFlag_flagGlobe__T50i3"
}, St = (e) => {
	let t = e.toUpperCase().split("").map((e) => 127397 + e.charCodeAt(0));
	return String.fromCodePoint(...t);
}, Ct = ({ iso2: e }) => {
	if (!e) return /* @__PURE__ */ S("div", {
		className: R.flagContainer,
		children: /* @__PURE__ */ S("span", { className: R.flagGlobe })
	});
	let t = St(e);
	return /* @__PURE__ */ S("div", {
		className: R.flagContainer,
		children: /* @__PURE__ */ S("span", {
			className: R.flagEmoji,
			children: t
		})
	});
}, wt = r(({ iso2: e, closeIcon: t }, n) => {
	let r = l(null), { phone: i, iso2: a, handleChange: s, handleClear: c } = xt(e), [d, f] = u(!1);
	o(n, () => ({ getValue: () => i }));
	let p = F(i, a), m = i.length >= p.placeholder.length, h = i && (d || m);
	return /* @__PURE__ */ S("div", {
		className: L.root,
		children: /* @__PURE__ */ C("label", {
			className: j(L.field, (i || a) && L.fieldHasValue),
			children: [
				/* @__PURE__ */ S("div", {
					className: L.flagButton,
					children: /* @__PURE__ */ S(Ct, { iso2: a })
				}),
				/* @__PURE__ */ C("div", {
					className: L.inputWrapper,
					children: [/* @__PURE__ */ C("div", {
						className: L.mask,
						"aria-hidden": "true",
						children: [i, /* @__PURE__ */ S("span", {
							className: L.maskVisible,
							children: p.placeholder.slice(i.length)
						})]
					}), /* @__PURE__ */ S("input", {
						ref: r,
						type: "tel",
						inputMode: "tel",
						className: L.input,
						value: i,
						onChange: s,
						onFocus: () => f(!0),
						onBlur: () => f(!1),
						"data-testid": "phone-input"
					})]
				}),
				h && /* @__PURE__ */ S("div", {
					className: L.clearButton,
					children: t && t(c)
				})
			]
		})
	});
}), Tt = ({ className: e }) => {
	let t = `2023\u2013${(/* @__PURE__ */ new Date()).getFullYear()}`;
	return /* @__PURE__ */ C("span", {
		className: e,
		"data-tid": "Copyright",
		children: [
			/* @__PURE__ */ S("bdo", {
				dir: "ltr",
				children: "©"
			}),
			"\xA0",
			/* @__PURE__ */ S("bdo", {
				dir: "ltr",
				children: t
			}),
			"\xA0",
			/* @__PURE__ */ S("bdo", {
				dir: "ltr",
				children: "Funtech Loyalty Cards Services LLC"
			}),
			/* @__PURE__ */ S("bdo", {
				dir: "ltr",
				children: ", "
			}),
			/* @__PURE__ */ S("bdo", {
				dir: "ltr",
				children: "18+"
			})
		]
	});
}, z = {
	root: "FooterComponent_root___1qqJ",
	touch: "FooterComponent_touch__2Bm5O",
	divider: "FooterComponent_divider__ar0Y2",
	sections: "FooterComponent_sections__BV3dj",
	sectionTitle: "FooterComponent_sectionTitle__yNT5Y",
	linksList: "FooterComponent_linksList__J0uNM",
	link: "FooterComponent_link__YZvwc",
	socialLinks: "FooterComponent_socialLinks__Z_twB",
	socialLink: "FooterComponent_socialLink___9DwF",
	copyright: "FooterComponent_copyright__ZFFyN",
	emptySpace: "FooterComponent_emptySpace__OpuHh",
	section: "FooterComponent_section__9OwdB",
	copyrightDivider: "FooterComponent_copyrightDivider__homN9"
}, Et = ({ sections: e, socialLinks: t, RouterLink: n, isTouch: r, i18nGeoWidgetEnabled: i, i18nGeoWidgetBrand: a = "yango" }) => /* @__PURE__ */ C("footer", {
	className: j(z.root, { [z.touch]: r }),
	"data-tid": "FooterComponent",
	children: [
		/* @__PURE__ */ S("div", { className: z.divider }),
		/* @__PURE__ */ C("div", {
			className: z.sections,
			children: [e.map((e) => /* @__PURE__ */ C("div", {
				className: z.section,
				children: [/* @__PURE__ */ S("h3", {
					className: z.sectionTitle,
					children: e.title
				}), /* @__PURE__ */ S("ul", {
					className: z.linksList,
					children: e.links.map((e) => /* @__PURE__ */ S("li", { children: "location" in e ? /* @__PURE__ */ S(n, {
						to: e.location,
						className: z.link,
						children: e.text
					}) : /* @__PURE__ */ S("a", {
						href: e.href,
						className: z.link,
						target: "_blank",
						rel: "noreferrer",
						children: e.text
					}) }, e.text))
				})]
			}, e.title)), /* @__PURE__ */ S("div", {
				className: z.socialLinks,
				children: t.map(({ link: e, renderIcon: t, label: n }) => /* @__PURE__ */ S("a", {
					href: e,
					className: z.socialLink,
					target: "_blank",
					rel: "noreferrer",
					"aria-label": n,
					children: t()
				}, e))
			})]
		}),
		/* @__PURE__ */ S("div", { className: z.copyrightDivider }),
		/* @__PURE__ */ S(T, {
			enabled: i,
			brand: a,
			environment: "production",
			lang: "en",
			theme: "dark",
			children: /* @__PURE__ */ S(Tt, { className: z.copyright })
		}),
		r && /* @__PURE__ */ S("div", { className: z.emptySpace })
	]
}), B = y("remoteConfig");
function Dt(e) {
	let t = v(e);
	return {
		get flags() {
			return t;
		},
		ref: () => B,
		hydrate(e) {
			t = v(e);
		},
		toJSON: () => t.toJSON()
	};
}
//#endregion
//#region src/hooks/useRemoteConfig.ts
function Ot() {
	return _(B);
}
//#endregion
//#region src/lib/requestId.ts
function kt(e, t) {
	if (e == null) throw Error(`${t} is not initialized`);
}
var At = y("requestIdManager");
function jt(e) {
	let t, n = e?.traceparent || "";
	return typeof window > "u" && (t = ie(ae(e?.requestId), { parser: oe })), {
		get requestId() {
			return kt(t, "requestId"), t;
		},
		get traceparent() {
			return n;
		},
		ref() {
			return At;
		},
		hydrate(e) {
			t = ie(e.requestId, { parser: re }), n = e.traceparent;
		},
		toJSON() {
			return {
				requestId: this.requestId.root,
				traceparent: n
			};
		}
	};
}
//#endregion
//#region src/components/Picture/Picture.tsx
var Mt = ({ sources: e, src: t, srcSet: n, alt: r, className: i, width: a, height: o, loading: s, decoding: c, id: l, title: u, role: d, sizes: f, onError: p, onLoad: m }) => {
	let h = /* @__PURE__ */ S("img", {
		id: l,
		className: i,
		src: t,
		srcSet: n,
		alt: r,
		role: d,
		width: a,
		height: o,
		loading: s,
		decoding: c,
		title: u,
		sizes: f,
		onLoad: m,
		onError: p
	});
	return e && e.length > 0 ? /* @__PURE__ */ C("picture", { children: [e.map(({ srcSet: e, media: t, type: n, sizes: r }, i) => /* @__PURE__ */ S("source", {
		srcSet: e,
		media: t,
		type: n,
		sizes: r
	}, `${e || "source"}-${t || i}`)), h] }) : h;
}, Nt = "(max-width: 599px)", Pt = "(min-width: 600px)";
function Ft(e) {
	return e && /\/orig$/.test(e) ? e.replace("/orig", "").replace(/^.*?:\/\//, "//") : e;
}
var It = (e, t) => Object.entries(t).map(([t, n]) => `${e}/${n} ${t}`).join(", ");
function V(e, t) {
	return t ? `${e}/${t}` : e;
}
var Lt = (e) => e?.map(({ media: e, width: t }) => e ? `${e} ${t}` : t).join(", "), Rt = (e, t) => {
	if (!(!e || t == null)) return typeof t == "string" ? V(e, t) : It(e, t);
}, zt = (e) => {
	let t = {
		...e,
		...e.mobile && !e.mobile.media ? { mobile: {
			...e.mobile,
			media: Nt
		} } : {},
		...e.tablet && !e.tablet.media ? { tablet: {
			...e.tablet,
			media: Pt
		} } : {}
	};
	return (e) => {
		let n = Object.fromEntries(Object.entries(e).map(([e, t]) => [e, t && Ft(t)])), r = [], i = [], a = t.fallback, { fallbackUrl: o } = n, s = {
			src: o && a ? V(o, a.src) : void 0,
			srcSet: o && a ? Rt(o, a.srcSet) : void 0,
			sizes: a ? Lt(a.sizes) : void 0
		};
		return Object.keys(t).forEach((e) => {
			let a = t[e], o = n[`${e}Url`];
			if (a && o && typeof a.srcSet == "object" && e !== "fallback") {
				let e = a.srcSet ? It(o, a.srcSet) : void 0, t = a.href ? V(o, a.href) : void 0;
				r.push({
					media: a.media,
					type: a.type,
					srcSet: e,
					sizes: Lt(a.sizes)
				}), i.push({
					media: a.media,
					href: t,
					imageSrcSet: e
				});
			}
		}), {
			sources: r,
			img: s,
			preloadLinks: i
		};
	};
}, H = y("featureFlags");
function Bt(e) {
	let t = v(), n = [], r = {}, i = [];
	e && a(e);
	function a(e) {
		t = v(e.flags), n = e.testIds || [], r = e.grouped || {}, i = e.rumSlots || [];
	}
	return {
		get flags() {
			return t;
		},
		get testIds() {
			return n;
		},
		get grouped() {
			return r;
		},
		get rumSlots() {
			return i;
		},
		ref: () => H,
		hydrate: a,
		toJSON() {
			return {
				flags: t.toJSON(),
				testIds: n,
				grouped: r,
				rumSlots: i
			};
		}
	};
}
//#endregion
//#region src/hooks/useFeatureFlags.ts
function Vt() {
	return _(H);
}
//#endregion
//#region src/lib/featureFlagsOverride.ts
var Ht = "ff_";
function Ut(e, t = Ht) {
	return e ? [...new URL(e, "http://placeholder").searchParams.entries()].reduce((e, [n, r]) => {
		if (!n.startsWith(t) || n.length === t.length) return e;
		let i = n.slice(t.length);
		try {
			e[i] = JSON.parse(r);
		} catch {
			e[i] = r;
		}
		return e;
	}, {}) : {};
}
//#endregion
//#region src/lib/script.ts
var U = (e, t = document.body, n = {}, r = void 0) => new Promise((i, a) => {
	let o = document.createElement("script");
	o.type = "text/javascript", o.src = e, o.onload = i, o.onerror = a, Object.keys(n).forEach((e) => {
		let t = n[e];
		typeof t == "string" && o.setAttribute(e, t), typeof t == "boolean" && o.setAttribute(e, "");
	}), r ? t.insertAdjacentElement(r, o) : t.appendChild(o);
}), W = {}, Wt = async (e, ...t) => {
	if (e in W) {
		let t = W[e];
		if (t) return Promise.resolve(t);
	}
	let n = await U(e, ...t);
	return W[e] = n, n;
};
async function Gt(e, t, n) {
	let { to: r = document.body, params: i = {}, errorMessage: a = `Script "${e}" load error` } = t || {}, o;
	try {
		o = await U(e, r, i);
	} catch (e) {
		throw e instanceof Error && n.error({ error: e }, a), e;
	}
	return o;
}
//#endregion
//#region src/lib/gtm.ts
var Kt = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content"
], qt = [
	"gclid",
	"fbclid",
	"yclid",
	"ttclid",
	"rb_clickid"
], Jt = [...Kt, ...qt], G = "dataLayer", K = globalThis, Yt = y("gtmService");
function Xt({ logger: e, trackedQueryParamsStore: t, nonce: n }) {
	let r, i, a = !1, o, s = n ?? "", c;
	async function l(t) {
		if (!t.containerId) {
			e.error("You must specify `container` query parameter for GTM!");
			return;
		}
		if (a) return;
		K[G] || (K[G] = []), c = t.source, a = !0, i = t.containerId, r = t.userId, o = K[G], o.push({ data_layer_nonce: s }), o.push({
			"gtm.start": (/* @__PURE__ */ new Date()).getTime(),
			event: "gtm.js"
		});
		let n = new URL("https://www.googletagmanager.com/gtm.js");
		n.searchParams.set("id", i), n.searchParams.set("l", G);
		try {
			await Wt(n.toString(), document.head, {
				async: !0,
				nonce: s
			}, "afterbegin");
		} catch (t) {
			e.error({ error: t }, "GTM load failed");
		}
		o.push(u());
	}
	function u() {
		return {
			source: c,
			container: i,
			...t?.getParams(Jt)
		};
	}
	function d(e) {
		if (!r || !o) return;
		let t = {
			source: c,
			container: i,
			...u(),
			...e,
			userId: r
		};
		o.push(t);
	}
	return {
		initialize: l,
		send: d,
		ref: () => Yt,
		hydrate: (e) => {
			s = e;
		},
		toJSON: () => s
	};
}
//#endregion
//#region src/hooks/useGtmService.ts
function Zt() {
	return f(Yt);
}
//#endregion
//#region src/lib/queryParams.ts
var Qt = "query_params", $t = () => typeof window > "u" ? {} : Object.fromEntries(new URLSearchParams(window.location.search)), en = (e, t) => t.length === 0 ? e : t.reduce((t, n) => {
	let r = e[n];
	return r && (t[n] = r), t;
}, {}), tn = y("queryParamsStore");
function nn(e) {
	let { storage: t, storageKey: n = Qt } = e, r = t.get(n) ?? {};
	function i(e) {
		Object.keys(e).length !== 0 && t.set(n, e) && (r = e);
	}
	function a() {
		return Object.keys(r).length === 0 && i($t()), r;
	}
	function o(e) {
		return en(r, e);
	}
	return {
		getParams: o,
		initialize: a,
		ref: () => tn
	};
}
//#endregion
//#region src/hooks/useQueryParamsStore.ts
function rn() {
	return f(tn);
}
//#endregion
//#region src/lib/lazyFactory.ts
function q(e) {
	let t = null;
	return () => (t === null && (t = e()), t);
}
//#endregion
//#region src/lib/payments/offers.ts
var J = (e = []) => e.reduce((e, t) => {
	let n = Number(t);
	return Number.isInteger(n) && e.push(n), e;
}, []), an = (e = {}) => Object.keys(e).filter((t) => !!e[t]);
function Y(e, t) {
	let n = e.analyticData?.batchId, r = e.analyticData?.positionId, i = e.catalogCompositeOffer?.tariffOffer?.name, a = e.catalogCompositeOffer?.optionOffers?.[0]?.name;
	return {
		...e,
		eventSessionId: t,
		offerPositionsData: n ? { offersBatchId: { [n]: { offersPositionIds: [r] } } } : {},
		billingProductIds: `${i || "NONE"}, ${a || "NONE"}`
	};
}
var on = async (e, t) => {
	let { page: n, places: r, extraParams: i } = t, { sessionId: a, result: o } = await e.getBestOffers(n, r, i);
	return r.map((e) => {
		let t = o[e];
		return !t || t.target === null ? null : Y(t, a ?? "");
	}).filter((e) => e !== null);
}, sn = async (e, t) => {
	let { page: n, places: r, extraParams: i } = t, { sessionId: a, result: o } = await e.getCarouselOffers(n, r, i), s = {};
	return Object.keys(o).forEach((e) => {
		s[e] = (o[e] ?? []).map((e) => Y(e, a ?? ""));
	}), s;
}, cn = async (e, t) => {
	let { target: n, features: r, extraParams: i } = t, a = {
		target: n,
		features: r
	}, { sessionId: o, result: s } = await e.getBestOffers([a], i), c = s.get(a) ?? null;
	return c ? [Y(c, o ?? "")] : [];
}, ln = async (e, t) => {
	let { featureTargets: n, extraParams: r } = t, i = n.map(({ target: e, billingFeatureName: t }) => ({
		target: e,
		features: [t]
	})), { sessionId: a, result: o } = await e.getBestOffers(i, r);
	return i.map((e) => {
		let t = o.get(e) ?? null;
		return t ? Y(t, a ?? "") : null;
	}).filter((e) => e !== null);
};
function un(e, { featureFlags: t, logger: n }) {
	let r = e(), i = {
		expTestIds: J(t.testIds),
		expFlags: an(t.flags.toJSON())
	};
	async function a(e) {
		try {
			return "featureTargets" in e ? await ln(r, {
				featureTargets: e.featureTargets,
				extraParams: {
					...i,
					...e.extraParams
				}
			}) : "target" in e ? await cn(r, {
				target: e.target,
				features: e.features,
				extraParams: {
					...i,
					...e.extraParams
				}
			}) : await on(r, {
				places: e.places,
				page: e.page,
				extraParams: {
					...i,
					...e.extraParams
				}
			});
		} catch (t) {
			throw t instanceof Error && n.error({
				error: t,
				params: e
			}, "Failed to get offers"), t;
		}
	}
	async function o(e) {
		try {
			let t = {
				...i,
				...e.extraParams
			};
			return await sn(r, {
				places: e.places,
				page: e.page,
				extraParams: t
			});
		} catch (t) {
			throw t instanceof Error && n.error({
				error: t,
				params: e
			}, "Failed to get offers carousel"), t;
		}
	}
	return {
		getOffers: a,
		getOffersCarousel: o
	};
}
//#endregion
//#region src/lib/disposable.ts
function dn() {
	let e = /* @__PURE__ */ new Set(), t = !1;
	return {
		get disposed() {
			return t;
		},
		add(n) {
			return t ? (n(), () => {}) : (e.add(n), () => {
				e.delete(n);
			});
		},
		dispose() {
			if (t) return;
			t = !0;
			let n = Array.from(e).reverse();
			e.clear();
			let r = [];
			if (n.forEach((e) => {
				try {
					e();
				} catch (e) {
					r.push(e);
				}
			}), r.length === 1) throw r[0];
			if (r.length > 1) {
				let e = /* @__PURE__ */ Error("Multiple disposal errors");
				throw Object.assign(e, { errors: r }), e;
			}
		}
	};
}
//#endregion
//#region src/lib/payments/widget.ts
function fn(e, t, n, r) {
	return new le(e, {
		eventSessionId: t,
		offersBatchId: n,
		offersPositionIds: [r],
		theme: e.options.theme
	});
}
var pn = (e, { onClose: t, onPurchaseSuccess: n, onPurchaseError: r, onError: i, onLoad: a, onScenarioChange: o, onSuccessClose: s, onNeedAuth: c }) => {
	let l = !1;
	return e.on("*", (e) => {
		switch (e.name) {
			case "close":
				t?.(), l &&= (s?.(), !1);
				break;
			case "purchase-success":
				l = !0, n?.(e);
				break;
			case "purchase-error":
				r?.(e);
				break;
			case "error":
				i?.(e);
				break;
			case "page-mount":
				o?.(e.data.scenario);
				break;
			case "load":
				a?.();
				break;
			case "need-auth":
				c?.();
				break;
			default: break;
		}
	});
};
function mn(e, t) {
	e.setAttribute("aria-hidden", String(t));
}
function hn(e, t) {
	e.setAttribute("data-scenario", t);
}
function gn(e, t, n) {
	let { eventSessionId: r, batchId: i, positionId: a } = n, o = fn(e, r, i, a), s;
	return {
		destroy() {
			s?.(), o.destroy(), o.unmount();
		},
		async mount(e, n, r) {
			try {
				return s = pn(o, {
					...r,
					onLoad: () => {
						mn(n, !1), r.onLoad?.();
					},
					onClose: () => {
						mn(n, !0), r.onClose?.();
					}
				}), o.setOnScenarioChange((e) => {
					hn(n, e), r.onScenarioChange?.(e);
				}), await o.mount({
					offer: e,
					targetNode: n
				});
			} catch (e) {
				throw e instanceof Error && t.error({ error: e }, "Couldn't open payment widget"), s?.(), e;
			}
		}
	};
}
//#endregion
//#region src/lib/payments/paymentPlace.ts
function _n(e) {
	return "places" in e;
}
var vn = ({ getOffersClient: e, getPwTools: t, getPaymentAnalytics: n, getWidgetTargetNode: r, modalController: i, logger: a }) => (o) => {
	let s = n(), c = "page" in o ? o.page : "", l = (e) => ({
		eventSessionId: e.eventSessionId,
		positionId: e.analyticData.positionId,
		position: Number(e.analyticData.positionId),
		batchId: e.analyticData.batchId,
		place: e.place ?? "",
		url: window.location.href,
		page: c
	});
	return {
		analytics: {
			async offerShowed(e) {
				s.sendOfferShow(l(e));
			},
			async offerClicked(e) {
				s.sendOfferClick(l(e));
			}
		},
		async getOffers() {
			let t = await e().getOffers(o);
			return t.length && s.sendOffersLoadResult(t), t;
		},
		async getCarouselOffers() {
			let t = e();
			if (!_n(o)) return a.error("Current payment place params are not valid for carousel request"), {};
			let n = await t.getOffersCarousel(o);
			return Object.keys(n).forEach((e) => {
				let t = n?.[e];
				t && s.sendOffersLoadResult(t);
			}), n;
		},
		async checkout(e, n, o) {
			let s = r();
			if (!s) {
				a.error("No target node for payment widget found");
				return;
			}
			let c = gn(t(), a, {
				eventSessionId: e.eventSessionId,
				batchId: e.analyticData.batchId,
				positionId: e.analyticData.positionId
			}), l = dn();
			if (l.add(() => c.destroy()), l.add(i.scenario.listen(() => {
				i.scenario.get() === null && l.dispose();
			})), o) {
				let e = () => l.dispose();
				o.addEventListener("abort", e), l.add(() => o.removeEventListener("abort", e));
			}
			let u = (e) => {
				l.dispose(), i.close(), e?.();
			}, d = {
				...n,
				onClose: () => u(n.onClose),
				onNeedAuth: () => u(n.onNeedAuth),
				onScenarioChange: (e) => {
					l.disposed || (i.open(e), n.onScenarioChange?.(e));
				}
			};
			try {
				await c.mount(e, s, d);
			} catch (e) {
				throw l.dispose(), e;
			}
		}
	};
};
//#endregion
//#region src/lib/payments/analytics.ts
function yn(e) {
	return {
		content_group_uuid: e.contentId,
		promotion_id: e.promotionId
	};
}
var bn = (e, t) => {
	let { featureFlags: n, channel: r, counterId: i, service: a, logger: o } = t, s = e().plusPaymentEvents;
	return {
		sendOfferClick: async (e) => {
			try {
				e.customParams && s.updateCustomParameters(yn(e.customParams)), s.offerClick({
					session_id: e.eventSessionId,
					offers_position_id: e.positionId,
					offers_batch_id: e.batchId,
					page: e.page,
					place: e.place,
					from: "",
					position: e.position,
					url: e.url
				});
			} catch (e) {
				o.error({ error: e }, "sendOfferClick error");
			}
		},
		sendOfferShow: async (e) => {
			try {
				e.customParams && s.updateCustomParameters(yn(e.customParams)), s.offerShow({
					session_id: e.eventSessionId,
					offers_position_id: e.positionId,
					offers_batch_id: e.batchId,
					position: e.position,
					page: e.page,
					place: e.place,
					from: "",
					url: e.url
				});
			} catch (e) {
				o.error({ error: e }, "sendOfferShow error");
			}
		},
		sendOffersLoadResult: async (e) => {
			try {
				if (!e[0]) return;
				let t = J(n.testIds).join(","), { eventSessionId: o } = e[0];
				s.frontSessionStart({
					service: a,
					service_channel: r,
					session_id: o,
					external_test_ids: t,
					external_triggered_test_ids: t
				}, String(i)), e.forEach((e) => {
					s.loadOffersResulted({
						session_id: o,
						target: e.target,
						resulted_offer_position_ids: [e.analyticData.positionId],
						offers_batch_id: e.analyticData.batchId
					});
				});
			} catch (e) {
				o.error({ error: e }, "sendOffersLoadResult error");
			}
		}
	};
};
//#endregion
//#region src/lib/payments/modal.ts
function xn() {
	let e = b(null);
	return {
		open: (t) => {
			e.set(t);
		},
		close: () => {
			e.set(null);
		},
		scenario: e.seal()
	};
}
//#endregion
//#region src/lib/payments/index.ts
var X = y("payments"), Sn = "default", Cn = { web: {
	mode: "iframe",
	platform: "web",
	acqPlatform: "Web"
} }, wn = (e) => {
	let { sessionParams: t, serviceParams: n, lang: r, puid: i } = e, a = {
		mode: Cn.web.mode,
		platform: Cn.web.platform,
		preloadManager: !1,
		lang: r,
		brand: n.brand,
		puid: i ? String(i) : null,
		widgetServiceName: n.widgetServiceName,
		theme: n.theme,
		environment: t.environment,
		serviceSessionId: t.serviceSessionId,
		authMethod: t.authMethod ?? Sn
	};
	return ce.from(a);
};
function Tn(e) {
	let { logger: t, featureFlags: n, lang: r, authManager: i, serviceParams: a, sessionParams: o, requester: s, getWidgetTargetNode: c } = e, l = q(() => wn({
		serviceParams: a,
		sessionParams: o,
		lang: r,
		puid: i.userProfile?.puid
	})), u = q(() => new se({
		lang: r,
		puid: i.userProfile?.puid ? String(i.userProfile.puid) : null,
		brand: a.brand,
		requester: s,
		platform: Cn.web.acqPlatform,
		authMethod: o.authMethod ?? Sn,
		service: a.widgetServiceName,
		environment: o.environment,
		oAuthToken: null
	})), d = q(() => un(u, {
		logger: t,
		featureFlags: n
	})), f = q(() => bn(l, {
		featureFlags: n,
		channel: a.channel,
		counterId: a.counterId,
		service: a.name,
		logger: e.logger
	})), p = xn();
	return {
		modal: p,
		createPaymentPlace: vn({
			getOffersClient: d,
			getPwTools: l,
			getPaymentAnalytics: f,
			getWidgetTargetNode: c,
			modalController: p,
			logger: t
		}),
		ref: () => X
	};
}
//#endregion
//#region src/hooks/usePaymentPlaceResource.ts
var En = (e) => ee({
	key: (t) => [e, JSON.stringify(t.variables)].join(":"),
	fetch: (e) => e.fetch()
});
function Dn(e, t, n) {
	let r = _(X), i = d(() => r.createPaymentPlace(e)), [a] = p(t({
		variables: e,
		fetch: n(i)
	}));
	return {
		offers: a,
		analytics: i.analytics,
		checkout: i.checkout
	};
}
//#endregion
//#region src/hooks/usePaymentPlace.ts
var On = En("paymentPlace");
function kn(e, t) {
	return e.find((e) => Object.entries(t).every(([t, n]) => e[t] === n)) ?? null;
}
function An(e) {
	let { offers: t, checkout: n, analytics: r } = Dn(e, On, (e) => e.getOffers);
	return c(() => ({
		offers: t,
		checkout: n,
		analytics: r,
		selectOfferBy: (e) => t?.length ? kn(t, e) : null
	}), [
		t,
		r,
		n
	]);
}
//#endregion
//#region src/hooks/useCarouselPaymentPlace.ts
var jn = En("carousel");
function Mn(e) {
	let { offers: t, checkout: n, analytics: r } = Dn(e, jn, (e) => e.getCarouselOffers);
	return c(() => ({
		offers: t,
		checkout: n,
		analytics: r,
		selectOffersByPlace: (e) => t?.[e] ?? null
	}), [
		t,
		r,
		n
	]);
}
//#endregion
//#region src/lib/dcb/createDcbAssign.ts
var Nn = "default";
function Pn({ brand: e, environment: t, requester: n }) {
	let r = q(() => new ue({
		brand: e,
		environment: t,
		authMethod: Nn,
		getAuthToken: () => null,
		requester: n
	}));
	return async (e) => String(await r().assign(e ?? {})) === "SUCCESS";
}
//#endregion
//#region src/lib/dcb/createDcbManager.ts
var Fn = y("dcbManager"), In = 200, Ln = 10;
function Rn({ brand: e, environment: t, requester: n, getIsAuthorized: r, getHasSubscription: i, logger: a }) {
	let o = Pn({
		brand: e,
		environment: t,
		requester: n
	}), s = b("idle"), c = s.seal(), l = !1;
	async function u() {
		if (l || typeof window > "u" || (l = !0, !r() || i())) return;
		s.set("pending");
		let e = setTimeout(() => {
			s.get() === "pending" && s.set("screen");
		}, In);
		try {
			if (await o({ maxAttempts: Ln })) {
				window.location.reload();
				return;
			}
		} catch (e) {
			a.warn({ error: e }, "DCB autolink assign failed");
		} finally {
			clearTimeout(e);
		}
		s.set("done");
	}
	return {
		phase: c,
		run: u,
		ref: () => Fn
	};
}
//#endregion
//#region src/hooks/useDcbAutolink.ts
var zn = b("idle").seal();
function Bn() {
	let e = f(Fn), t = h(e?.phase ?? zn);
	return a(() => {
		e?.run();
	}, [e]), t === "screen";
}
//#endregion
//#region src/lib/vitals/metric.duration.ts
function Vn(e, t) {
	let n = /* @__PURE__ */ new Set(), r = (t) => {
		n.forEach((n) => n(e, t));
	}, i = () => {
		let e = null;
		return {
			begin() {
				e = performance.now();
			},
			end() {
				e !== null && (r(performance.now() - e), e = null);
			},
			cancel() {
				e = null;
			}
		};
	}, a;
	return {
		observe(e) {
			return n.add(e), () => n.delete(e);
		},
		measure() {
			return t?.persistent ? (a ??= i(), a) : i();
		}
	};
}
//#endregion
//#region src/lib/vitals/metric.web-vitals.ts
function Hn(e) {
	let t = /* @__PURE__ */ new Set(), n = (e, n) => {
		t.forEach((t) => t(e, n));
	}, r = /* @__PURE__ */ new Map(), i = () => {
		if (!window || !PerformanceObserver) return;
		let { fcp: t, cls: i, lcp: a, inp: o } = e;
		t && r.set("fcp", Un((e) => n(t, e))), i && console.warn("Not implemented web vitals metric CLS"), a && console.warn("Not implemented web vitals metric LCP"), o && console.warn("Not implemented web vitals metric INP");
	}, a = () => {
		r.forEach((e) => e.disconnect()), r.clear();
	};
	return {
		observe(e) {
			return t.size === 0 && i(), t.add(e), () => {
				t.delete(e), t.size === 0 && a();
			};
		},
		measure() {}
	};
}
function Un(e) {
	let t = new PerformanceObserver((n) => {
		let r = n.getEntriesByName("first-contentful-paint")[0];
		r && (t.disconnect(), e(r.startTime));
	});
	return t.observe({
		type: "paint",
		buffered: !0
	}), t;
}
//#endregion
//#region src/lib/vitals/metric.rival-route.ts
function Wn(e) {
	let t = /* @__PURE__ */ new Set(), n = (e, n, r) => {
		t.forEach((t) => t(e, n, r));
	};
	return {
		observe(e) {
			return t.add(e), () => t.delete(e);
		},
		measure(t) {
			let r = t.routingStart, i, a = (e) => {
				n(e, performance.now() - r, i);
			}, o = {}, { render: s, fetch: c, complete: l } = e;
			return (s || c || l) && (o.onChange = (e, t) => {
				r = performance.now(), i = {
					from: e,
					to: t
				};
			}), s && (o.onRender = () => a(s)), c && (o.onFetch = () => a(c)), l && (o.onComplete = () => a(l)), o;
		}
	};
}
//#endregion
//#region src/lib/vitals/manager.ts
var Gn = y("vitalsManager");
function Kn(e) {
	let { globals: t = [], onReport: n } = e, r = /* @__PURE__ */ new Map(), i = {
		attach(e) {
			r.has(e) || r.set(e, e.observe(n));
		},
		detach(e) {
			r.get(e)?.(), r.delete(e);
		},
		ref: () => Gn
	};
	return t.forEach((e) => i.attach(e)), i;
}
//#endregion
//#region src/hooks/useVitalMetric.ts
function qn(e, ...[t]) {
	let n = f(Gn), r = e.measure;
	return s(() => (n?.attach(e), () => n?.detach(e)), [n, e]), c(() => r(t), [r]);
}
//#endregion
//#region src/lib/authManager.ts
var Jn = y("authManager");
function Yn(e) {
	let t = !1, n = "";
	return {
		get isAuthorized() {
			return t;
		},
		get yandexuid() {
			return n;
		},
		setIsAuthorized(e) {
			t = e;
		},
		setYandexuid(e) {
			n = e;
		},
		getLoginUrl(t) {
			let n = new URL("/auth", e.passportHost);
			return n.searchParams.set("origin", e.origin), n.searchParams.set("lang", e.lang), n.searchParams.set("retpath", t.toString()), n;
		},
		getLogoutUrl(t) {
			let r = new URL("/passport", e.passportHost);
			return r.searchParams.set("mode", "logout"), r.searchParams.set("yu", n), r.searchParams.set("retpath", t.toString()), r;
		},
		getAuthAccountUrl(t, r) {
			let i = new URL("/auth", e.passportHost);
			return i.searchParams.set("login", t), i.searchParams.set("yu", n), i.searchParams.set("origin", e.origin), i.searchParams.set("lang", e.lang), i.searchParams.set("retpath", r.toString()), i;
		},
		getChangeMultiAccountUrl(t, r) {
			let i = new URL("/passport", e.passportHost);
			return i.searchParams.set("action", "change_default"), i.searchParams.set("mode", "embeddedauth"), i.searchParams.set("uid", t), i.searchParams.set("yu", n), i.searchParams.set("origin", e.origin), i.searchParams.set("lang", e.lang), i.searchParams.set("retpath", r.toString()), i;
		},
		getAddAccountUrl(t) {
			let n = new URL("/auth", e.passportHost);
			return n.searchParams.set("mode", "add-user"), n.searchParams.set("origin", e.origin), n.searchParams.set("lang", e.lang), n.searchParams.set("retpath", t.toString()), n;
		},
		ref() {
			return Jn;
		},
		hydrate(e) {
			t = e.isAuthorized, n = e.yandexuid;
		},
		toJSON() {
			return {
				isAuthorized: t,
				yandexuid: n
			};
		}
	};
}
function Z(e, t) {
	let n = new URL("/push", e);
	return n.searchParams.set("retpath", t.toString()), n.searchParams.set("uuid", Zn()), n;
}
function Xn({ ssoHost: e, ...t }) {
	let n = Yn(t);
	return {
		get isAuthorized() {
			return n.isAuthorized;
		},
		get yandexuid() {
			return n.yandexuid;
		},
		setIsAuthorized: n.setIsAuthorized,
		setYandexuid: n.setYandexuid,
		getLoginUrl(t) {
			return n.getLoginUrl(Z(e, t));
		},
		getLogoutUrl(t) {
			return n.getLogoutUrl(Z(e, t));
		},
		getAuthAccountUrl(t, r) {
			return n.getAuthAccountUrl(t, Z(e, r));
		},
		getChangeMultiAccountUrl(t, r) {
			return n.getChangeMultiAccountUrl(t, Z(e, r));
		},
		getAddAccountUrl(t) {
			return n.getAddAccountUrl(Z(e, t));
		},
		ref: n.ref,
		hydrate: n.hydrate,
		toJSON: n.toJSON
	};
}
function Zn() {
	return typeof crypto < "u" && "randomUUID" in crypto ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
		let t = Math.random() * 16 | 0;
		return (e === "x" ? t : t & 3 | 8).toString(16);
	});
}
//#endregion
//#region src/hooks/useAuthManager.ts
function Qn() {
	return _(Jn);
}
//#endregion
//#region src/lib/backendClient.ts
var $n = class {
	baseUrl;
	headers;
	requester;
	requestIdManager;
	realHost;
	constructor({ baseUrl: e, headers: t, requester: n, requestIdManager: r }) {
		this.baseUrl = e, this.requester = n, this.headers = t, this.requestIdManager = r, this.realHost = new URL(this.baseUrl).hostname;
	}
	post(e, t, n) {
		let r = {
			...this.headers,
			...n?.headers,
			"content-type": "application/json",
			[E.RequestId]: this.requestIdManager.requestId.child,
			[E.Traceparent]: this.requestIdManager.traceparent,
			"x-real-host": this.realHost
		};
		return this.requester.post(e, JSON.stringify(t), {
			headers: r,
			signal: n?.signal
		}).then(({ data: e }) => e);
	}
	async get(e, t, n) {
		let r = {
			...this.headers,
			...n?.headers,
			[E.RequestId]: this.requestIdManager.requestId.child,
			[E.Traceparent]: this.requestIdManager.traceparent,
			"x-real-host": this.realHost
		}, i = t ? `${e}?${new URLSearchParams(t).toString()}` : e;
		return this.requester.get(i, {
			headers: r,
			signal: n?.signal
		}).then(({ data: e }) => e);
	}
	makeUrl(e) {
		return `${this.baseUrl}${e}`;
	}
	ref() {
		return er;
	}
}, er = y("backendClient");
//#endregion
//#region src/hooks/useBackendClient.ts
function tr() {
	return _(er);
}
var nr = { digit: "Timer_digit__4xnnk" }, rr = 1e3, Q = (e) => String(e).padStart(2, "0");
function $(e) {
	let t = Math.max(0, e);
	return {
		hours: Q(Math.floor(t / 36e5)),
		minutes: Q(Math.floor(t % 36e5 / 6e4)),
		seconds: Q(Math.floor(t % 6e4 / 1e3))
	};
}
function ir(e) {
	let { hours: t, minutes: n, seconds: r } = $(e);
	return `${t}:${n}:${r}`;
}
var ar = ({ durationMs: e, onExpire: t, onTick: n, className: r }) => {
	let o = l(null), s = l(null), c = l(null), u = l(t);
	u.current = t;
	let d = l(n);
	d.current = n;
	let f = i((e) => {
		let { hours: t, minutes: n, seconds: r } = $(e);
		o.current && o.current.textContent !== t && (o.current.textContent = t), s.current && s.current.textContent !== n && (s.current.textContent = n), c.current && c.current.textContent !== r && (c.current.textContent = r);
	}, []);
	a(() => {
		let t = Date.now(), n = setInterval(() => {
			let r = e - (Date.now() - t);
			r <= 0 ? (clearInterval(n), f(0), d.current?.(0), u.current?.()) : (f(r), d.current?.(r));
		}, rr);
		return () => clearInterval(n);
	}, [e, f]);
	let p = $(e);
	return /* @__PURE__ */ C("div", {
		className: r,
		dir: "ltr",
		children: [
			/* @__PURE__ */ S("span", {
				ref: o,
				className: nr.digit,
				children: p.hours
			}),
			/* @__PURE__ */ S("span", { children: ":" }),
			/* @__PURE__ */ S("span", {
				ref: s,
				className: nr.digit,
				children: p.minutes
			}),
			/* @__PURE__ */ S("span", { children: ":" }),
			/* @__PURE__ */ S("span", {
				ref: c,
				className: nr.digit,
				children: p.seconds
			})
		]
	});
}, or = "counterOfferLastShownTimestamp", sr = 2e4, cr = 1440 * 60 * 1e3;
function lr({ storage: e, hasSubscription: t, hasActiveModal: n, hasCounterOffer: r, isShowForced: i, activityEvents: o, subscribeActivity: s, delayMs: l = sr }) {
	let u = c(() => {
		let t = b(!1), n = null, r = !0;
		return {
			visible: t.seal(),
			setBlocked(e) {
				r = e;
			},
			isCooldownActive() {
				let t = e.local.get(or) ?? "0";
				return Date.now() - parseInt(t, 10) < cr;
			},
			show() {
				r || this.isCooldownActive() || (t.set(!0), e.local.set(or, String(Date.now())));
			},
			hide() {
				t.set(!1);
			},
			startTimer(e) {
				this.clearTimer(), n = setTimeout(() => {
					this.show();
				}, e);
			},
			clearTimer() {
				n &&= (clearTimeout(n), null);
			}
		};
	}, [e]);
	u.setBlocked(t || n || !r);
	let d = h(u.visible);
	return a(() => {
		t && (u.hide(), u.clearTimer());
	}, [t, u]), a(() => {
		i && u.show();
	}, [i, u]), a(() => {
		if (i || t || d || u.isCooldownActive()) return;
		u.startTimer(l);
		let e = () => u.startTimer(l);
		if (s) {
			let t = s(e);
			return () => {
				u.clearTimer(), t();
			};
		}
		return o.forEach((t) => document.addEventListener(t, e)), () => {
			u.clearTimer(), o.forEach((t) => document.removeEventListener(t, e));
		};
	}, [
		i,
		t,
		d,
		u,
		o,
		s,
		l
	]), {
		isVisible: d,
		hide: u.hide
	};
}
//#endregion
export { Pe as AnalyticsSenderProvider, $n as BackendClient, Te as EvgenLoggerDecorator, Et as FooterComponent, wt as PhoneInput, Mt as Picture, nt as Seo, ar as Timer, ht as Tooltip, xe as TrackingProvider, Gt as addScript, U as appendScript, er as backendClientRef, Yn as createAuthManager, Rn as createDcbManager, je as createEvgen, Bt as createFeatureFlags, Be as createFromBlock, Xt as createGtmService, Xn as createMDAuthManager, Tn as createPayments, zt as createPictureFactory, nn as createQueryParamsStore, Dt as createRemoteConfig, jt as createRequestIdManager, Wn as createRivalRouteMetric, it as createUseI18n, Vn as createVitalDurationMetric, Kn as createVitalsManager, Hn as createWebVitalsMetric, Fn as dcbManagerRef, D as evgenRef, H as featureFlagsRef, J as formatTestIds, ir as formatTimerValue, Z as getPushUrl, Ut as getUrlFeatureFlags, q as lazyFactory, X as paymentsRef, B as remoteConfigRef, At as requestIdManagerRef, rt as seoDictionary, Fe as useAnalytics, Qn as useAuthManager, tr as useBackendClient, Mn as useCarouselPaymentPlace, lr as useCounterOfferController, Bn as useDcbAutolink, Me as useEvgen, Vt as useFeatureFlags, Ve as useFromBlock, Zt as useGtmService, at as useI18n, st as useOuterClick, An as usePaymentPlace, rn as useQueryParamsStore, A as useRelativeUrl, Ot as useRemoteConfig, k as useSeoDefaults, He as useUpdateLocalSessionId, qn as useVitalMetric, Gn as vitalsManagerRef };
